import { AppDispatch, RootState, store } from '../index';
import { FetchState } from '../fetchState';
import { getList, getListSort, ListFilter, listSlice, ListType } from '../listHelper';
import { CancelToken } from 'axios';
import { EntityState } from '@api/models/enums/EntityState';
import { CertificateDto } from '@api/models/suppliers/CertificateDto';
import { certificateService } from '@api/services/services';

export interface DocumentListFilter extends ListFilter {
  state?: EntityState;
}

export type DocumentListState = ListType<CertificateDto, DocumentListFilter>;

const initialState: DocumentListState = {
  state: FetchState.None,
  data: undefined,
  query: {
    state: EntityState.Active,
    sortBy: 'name',
    sortDesc: false,
  },
};

export const documentListSlice = listSlice({
  name: 'documentList',
  initialState,
});

export const selectDocumentList = (state: RootState) => state.documentList;
export const documentListActions = documentListSlice.actions;

export const getDocumentList = (cancelToken: CancelToken) => (dispatch: AppDispatch) => {
  const storeState = store.getState();
  const data = selectDocumentList(storeState);

  const handleGetData = (size: number) => {
    return certificateService.query(
      {
        q: data.query.q,
        state: data.query.state,
        page: data.query.page,
        size: size,
        sort: getListSort(data),
      },
      { cancelToken: cancelToken as any }
    );
  };

  getList({
    dispatch,
    cancelToken,
    state: data.state,
    actions: documentListActions,
    getData: handleGetData,
  });
};
